<template>
    <div class="feed__container button-container">
        <span
            @click="reload"
            v-if="isSubPage"
            class="back__link flex"
        >
            <Back></Back> Powrót
        </span>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Back from '@/assets/img/arrow-left-solid.svg'

export default {
    components: {
        Back
    },
    computed: {
        ...mapGetters({isSubPage: 'pageType'})
    },
    methods: {
        ...mapActions(['resetState', 'loadPosts']),
        reload(){
            const payload = {
                page: null,
                year: true
            }
            this.resetState(payload);
            this.loadPosts();
        }
    }
}
</script>

